import { createSelector } from '@ngrx/store';

import { createEntityCollectionStore, memoizeSelector } from '@core/ngrx-legacy';
import type { TellentRole } from '@core/tellent-types';

import { EntityStoreKey } from '../types';

const idSelector = ({ externalId }: { externalId: string }) => externalId;

const { actions, selectors, reducer, namespace } = createEntityCollectionStore<TellentRole>()(
  EntityStoreKey.TellentRoles,
  {
    idSelector,
  },
);
export const selectRolesSelectOptions = memoizeSelector((appGuid: string) => {
  const selector = selectors.entities({ scope: appGuid });
  return createSelector(
    selector,
    roles =>
      roles.map(({ externalId, name }) => ({
        label: name,
        value: externalId,
      })) || [],
  );
});

const TellentRolesSelectors = { ...selectors, selectRolesOptions: selectRolesSelectOptions };

export {
  actions as TellentRolesActions,
  TellentRolesSelectors,
  reducer as TellentRolesReducer,
  namespace as TellentRolesNamespace,
};
